import { isEmpty } from "src/app/utils/is-empty";
import { KEYCLOAK_NO_RESOURCE_ROLE } from "src/app/components/list-advisor-accesses/constants";

export const createKeyCloakFmsKey = (role: string): string =>
  isEmpty(role) ? KEYCLOAK_NO_RESOURCE_ROLE : `keycloak.${role}`;
